import {
    GET_SALARY_LIST,
    UPDATE_SALARY_LIST,
    GET_NOT_PAYED_SALARY,
    PAY_SALARY,
    SHOW_PAYMENT_MODAL,
    HIDE_PAYMENT_MODAL,
} from "./salary.actionTypes";
import { DEED_STATUSES } from "../../config/constants";

export default function salary(state = {}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case SHOW_PAYMENT_MODAL:
            return {
                ...newState,
                showPayment: true,
            };
        case HIDE_PAYMENT_MODAL:
            return {
                ...newState,
                showPayment: false,
            };
        case GET_SALARY_LIST:
            const salaryList = action.salaryList.map((item) => ({
                ...item,
                canSendAct:
                    (!item.deed.status ||
                        item.deed.status == DEED_STATUSES.DECLINED.id) &&
                    item.totalSalary &&
                    item.payedSalaries &&
                    item.payedSalaries.length,
            }));

            return {
                ...newState,
                salaryList,
            };
        case UPDATE_SALARY_LIST:
            return {
                ...newState,
                salaryList: action.salaryList,
            };
        case GET_NOT_PAYED_SALARY:
            return {
                ...newState,
                distributorId: action.distributorId,
                notPayedSalaries: action.notPayedSalaries,
            };
        case PAY_SALARY:
        default:
            return newState;
    }
}
